import { formatDistanceToNow } from 'date-fns';
import { ru } from 'date-fns/locale';

export function formatCommentDate(dateString: string): string {
  if (!dateString) return 'недавно';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'недавно';
    return formatDistanceToNow(date, {
      addSuffix: true,
      locale: ru,
    });
  } catch {
    return 'недавно';
  }
}
